<template>
  <div>
    <van-nav-bar :title="barTitle" :left-text="leftText" @click-left="onClickLeft" />
    <van-row>
      <van-col :span="24" style="padding-top: 16px;padding-left: 16px;color: green">
        客户名称：{{form.client_name}}
      </van-col>
    </van-row>
    <van-form ref="form" @submit="save">
          <base-input v-model="form.customer_name" label='收款客户名称' disabled />
          <base-input v-model="form.bank" label='开户银行' disabled />
          <base-input v-model="form.account" label='银行账号' disabled />
          <base-input-number v-model="form.amount" label='金额' disabled />
          <base-input v-model="form.mobile" label='短信手机号' disabled />
          <base-input v-model="form.other" label='其他' disabled />
          <base-input v-model="form.comment" label='备注' disabled />
          <base-select v-model="form.status" :options="CONST.TRANSFER_STATUS" :required="true" label='状态' placeholder=" " />
      <div v-if="showSubmit" style="margin: 16px">
        <van-button round block type="info" native-type="submit">修改状态</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { mapGetters } from 'vuex'
import { modifyTransferStatus } from '@/api/transfer'
export default {
  name: 'TransferEdit',
  data() {
    return {
      barTitle: '转账信息',
      leftText: '',
      active: 0,
      data: [],
      showSubmit: false,

      queryCondition: {
        page: this.CONST.PAGINATION.PAGE,
        rows: this.CONST.PAGINATION.MAX_ROWS
      },
      form: {
        id: null,
        client_name: '',
        customer_name: '',
        bank: '',
        account: '',
        amount: null,
        mobile: '',
        other: '',
        comment: '',
        status: null
      }
    }
  },
  computed: {
    ...mapGetters(['selectedTransfer'])
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.resetForm();
      if (this.selectedTransfer) {
        this.barTitle = '转账信息';
        this.leftText = '返回';
        const data = this._.cloneDeep(this.selectedTransfer);
        this.showSubmit = data.status === 1 ? true : false;
        Toast.loading({
          message: '加载中...',
          forbidClick: true,
          loadingType: 'spinner',
          duration: 0,
          overlay: true
        })
        setTimeout(() => {
          this.form = data;
          Toast.clear()
        }, 1000)
      }
    },
    resetForm() {
      this.Utils.resetValue(this.form);
    },
    onClickLeft() {
      this.$router.push('/transfer/manage')
    },
    save() {
      if (this.form.status === 1) {
        this.toast('状态禁止修改为待转账，请检查！');
        return;
      }
      const status_name = this.CONST.TRANSFER_STATUS.find(item => item.id === this.form.status).name;
      modifyTransferStatus({
        id: this.form.id,
        client_name: this.form.client_name,
        status: this.form.status,
        status_name: status_name,
        mobile: this.form.mobile,
        create_time: this.form.create_time
      }).then(resp => {
        if (resp.success) {
          this.success(resp.msg);
          this.$router.push('/transfer/manage');
        }
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/transfer/transfer-edit.vue